import africa from './map-africa.jpg';
import asia from './map-asia.jpg';
import caribe from './map-caribe.jpg';
import europe from './map-europe.jpg';
import latam from './map-latam.jpg';
import middle from './map-middle.jpg';
import north from './map-north.jpg';
import pacific from './map-pacific.jpg';
import blank from './map-blank.jpg';

export default {
  africa,
  asia,
  caribe,
  europe,
  latam,
  middle,
  north,
  pacific,
  blank,
};
